import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4013c31e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "product-button-item--desktop" }, " Ещё! ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "product-button-item--mobile" }, " Хочу! ", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dash" }, " — ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dash dash--mobile" }, " -1 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "product-button__item hint" }, " Меньше ", -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isInCart)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("button", {
            class: "product-button__item product-button__item--increase",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('increase')), ["stop"]))
          }, _hoisted_4),
          _createElementVNode("button", {
            class: "product-button__item product-button__item--decrease",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('decrease')), ["stop"]))
          }, _hoisted_8)
        ], 64))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "product-button__item product-button__item--add",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('add')), ["stop"]))
        }, " Хочу! "))
  ]))
}